export default "__VITE_ASSET__Ds0E7ja1__"